import { typedUrlForRoute } from "$root/components/PlatformRouter/RoutesDef";
import { ForEach } from "@mdotm/utils/react-extra";
import { ActionText, AutoTooltip, Text, TooltipContent } from "@mdotm/shadcn/legacy/components";
import { Switch } from "@mdotm/shadcn/legacy/react-extensions";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";

export function LinkedPortfolioCounterWithTooltip({
	type,
	othersCount = 0,
	portfolios = [],
}: {
	type: "References" | "Benchmark" | "Universe" | "LegacyBenchmark";
	portfolios?: Array<{ uuid?: string; name?: string }>;
	othersCount?: number;
}): React.JSX.Element {
	return (
		<AutoTooltip
			disabled={!portfolios.length}
			overrideColor={themeCSSVars.palette_N200}
			position="left"
			trigger={({ innerRef }) => (
				<div ref={innerRef} className="tabular-nums text-right min-w-[64px]">
					{(othersCount ?? 0) + (portfolios.length ?? 0)}
				</div>
			)}
		>
			<TooltipContent>
				<Text as="div" type="Body/M/Bold" className="pb-2">
					<Switch
						case={type}
						match={{
							Benchmark: () => "This benchmark is linked to:",
							References: () => "This reference is linked to:",
							Universe: () => "This universe is linked to:",
							LegacyBenchmark: () => "This Benchmark is linked to:",
						}}
					/>
				</Text>
				<ul className="list-disc pl-4">
					<ForEach collection={portfolios}>
						{(item) => (
							<li>
								<ActionText
									href={typedUrlForRoute("PortfolioDetails", {
										portfolioUid: item.uuid!,
									})}
								>
									{item.name ?? "-"}
								</ActionText>
							</li>
						)}
					</ForEach>
				</ul>
				{othersCount > 0 && (
					<div className="px-2 pt-4">
						<div className="w-full h-0 border-b" style={{ borderColor: themeCSSVars.palette_N200 }} />
						<div className="pt-2">+{othersCount} Portfolios (of other users)</div>
					</div>
				)}
			</TooltipContent>
		</AutoTooltip>
	);
}
